import { observer } from 'mobx-react-lite'
import { PageLayout } from '@/features/jobs/details/components/PageLayout'
import { ProInfoSectionContainer } from '@/features/jobs/details/components/ProInfoSection'
import { ModalResponsesSectionContainer } from '@/features/jobs/details/components/ModalResponsesSection'
import { BookkeepingWorkItemsSectionContainer } from '@/features/jobs/details/bookkeeping-type/components/BookkeepingWorkItemsSection'
import { SupportSectionContainer } from '@/features/jobs/details/components/SupportSection/SupportSectionContainer'
import type { JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import type { BookkeepingViewModel } from '@/features/jobs/details/bookkeeping-type/BookkeepingViewModel'

interface BookkeepingJobOverviewTabProps {
  vm: JobDetailsViewModel
  bookkeepingVm: BookkeepingViewModel
}

export const BookkeepingJobOverviewTab = observer(
  function BookkeepingJobOverviewTab({
    vm,
    bookkeepingVm,
  }: BookkeepingJobOverviewTabProps) {
    return (
      <PageLayout
        asideTop={<ProInfoSectionContainer vm={vm} />}
        asideBottom={<SupportSectionContainer />}
      >
        <BookkeepingWorkItemsSectionContainer vm={bookkeepingVm} />

        <ModalResponsesSectionContainer
          vm={vm.questionsDisplayVm}
          sectionHeadline="Bookkeeping information summary"
          dialogHeadline="View your bookkeeping information summary"
        />
      </PageLayout>
    )
  },
)
